/** Canonical route when Tessera cannot be reached or billing status is unavailable. */
export const SERVICE_UNAVAILABLE_PATH = "/service-unavailable";

function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

/**
 * Navigate to the downtime page without a full reload (same pattern as paywall redirect).
 */
export function redirectToServiceUnavailable(): void {
  if (typeof window === "undefined") return;

  const current = normalizePathname(window.location.pathname);
  if (current === SERVICE_UNAVAILABLE_PATH) return;

  const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  try {
    window.history.pushState({ from: returnTo }, "", SERVICE_UNAVAILABLE_PATH);
    window.dispatchEvent(new PopStateEvent("popstate"));
  } catch {
    window.location.assign(SERVICE_UNAVAILABLE_PATH);
  }
}

/**
 * Leave `/service-unavailable` once billing status loads again.
 */
export function redirectFromServiceUnavailable(fallbackPath = "/dashboard"): void {
  if (typeof window === "undefined") return;

  const current = normalizePathname(window.location.pathname);
  if (current !== SERVICE_UNAVAILABLE_PATH) return;

  const state = window.history.state as { from?: unknown } | null;
  const from =
    typeof state?.from === "string" && state.from.trim()
      ? state.from
      : fallbackPath;
  const target = normalizePathname(from.split(/[?#]/)[0] ?? fallbackPath);
  const destination =
    target === SERVICE_UNAVAILABLE_PATH || !target.startsWith("/") ? fallbackPath : from;

  try {
    window.history.pushState({}, "", destination);
    window.dispatchEvent(new PopStateEvent("popstate"));
  } catch {
    window.location.assign(destination);
  }
}
